export default {
  navbar: {
    homePage: 'INVESTOR RELATIONS HOME PAGE',
    companyInfo: 'Company Information',
    AboutOrigin: "About Origin",
    History: "Origin History",
    ChairmanMessage: "Message from the Chairman",
    CEOMessage: "Message from the CEO",
    OrgChart: "Organization Structure",
    GroupStructure: "Group Structure",
    ManagementStructure: "Management Structure",
    Awards: "Awards Received",
    CorporateGovernance: "Corporate Governance",
    Sustainability: "Sustainability Management",

    FinancialInfo: "Financial Information",
    KeyInfo: "Key Financial Information",
    Statements: "Financial Statements",
    MDNA: "Management Discussion and Analysis",

    StockPriceInfo: "Stock Price Information",
    StockPrice: "Stock Price",
    HistoricalPrice: "Historical Stock Prices",

    ShareholderInfo: "Shareholder Information",
    BasicInfo: "Basic Information",
    MajorShareholders: "Major Shareholders",
    Dividend: "Dividend Payment",
    Meeting: "Shareholder Meeting",
    Subscription: "ORI - Subscription Rights for Capital Increase",
    WarrantInfo: "Warrant Holders Information",

    DebtInfo: "Debenture Information",
    CreditRating: "Credit Rating",
    BillExchange: "Bill of Exchange Information",

    NewsCenter: "News Center",
    SETNews: "SET Announcements",
    Press: "Press Releases",
    PrintNews: "Print Media News",
    EAd: "Electronic Advertising",
    Calendar: "IR Calendar",

    PublishedDocs: "Published Documents",
    OneReport: "56-1 One Report",
    Annual: "Annual Report",
    SustainabilityReport: "Sustainability Report",
    Form561: "Form 56-1",

    Presentation: "Presentation Activities",

    AnalystInfo: "Analyst Information",
    ContactAnalyst: "Contact Analyst",
    SecuritiesAnalysis: "Securities Analysis",

    ContactInfo: "Contact Information",
    ContactIR: "Contact IR",
    SubscribeEmail: "Subscribe to Newsletter",
    // เพิ่มตามเมนูอื่น ๆ
  },
  home: {
    stockSymbol: 'Stock Symbol',
    updated: 'Updated',
    changePercent: 'Change (%)',
    tradingVolume: 'Trading Volume',
    priceRange: 'Intraday Price Range',
    stockPriceBtn: 'Stock Price',
    factSheetBtn: 'Fact Sheet',
    marketClosed: "Market Closed"
  },
  homeAbout: {
    heading: 'Investor Relations',
    welcome: 'Welcome to the Investor Relations Homepage',
    description1: 'Origin Property Public Company Limited was founded in 2009 to engage in real estate development.',
    description2: 'The company focuses on developing condominium projects in convenient locations, such as areas',
    description3: 'along mass transit rail lines in Bangkok and surrounding areas, as well as locations near expressways.'
  },
  growthHistory: {
    title: 'Growth History of ORI',
    netProfit: 'Net Profit',
    totalIncome: 'Total Revenue'
  },
  FinancialInfoHome: {
    sectionTitle: 'Key Financial Information',
    MillionBaht: 'Million Baht',
    incomeTitle: 'Income',
    profitTitle: 'Profit',
    presaleTitle: 'Presale',
    backlogTitle: 'Backlog',
    quarterLabel: 'Quarterly',
    yearlyLabel: 'Yearly (Accumulated)',
  },
  latestDocuments: {
    sectionTitle: 'Latest Documents',
    year: 'year',
    financialStatement: 'Quarterly Financial Statement',
    analysisTitle: 'Management Discussion and Analysis',
    download: 'Download'
  },
  printMediaNews: {
    printNews: 'Print Media News',
    setNews: 'SET Announcements',
    viewAll: 'View All',
    readMore: 'Read More'
  },
  contactInvestorRelations: {
    sectionTitle: 'Contact Investor Relations',
    phone: 'Phone:',
    fax: 'Fax:',
    email: 'Email:',
    subscribeTitle: 'Subscribe for Updates',
    subscribeDescription: 'You can subscribe to receive electronic news. We will send you an email whenever the company makes announcements via the website.',
    subscribeButton: 'Subscribe Now'
  },
  footer: {
    contactTitle: 'Contact Investor Relations',
    phone: 'Phone: 081-1311064',
    fax: 'Fax: 02-3988066',
    email: 'Email: ir@origin.co.th',
    subscribeTitle: 'Subscribe for Updates',
    subscribeDesc: 'You can register to receive electronic news. We will send updates to your email when announcements are made on the website.',
    subscribeButton: 'Subscribe Now',
    irHomeTitle: 'IR Homepage',
    menu: {
      financial: 'Financial Information',
      stock: 'Stock Price Info',
      shareholder: 'Shareholder Information',
      warrant: 'Warrantholder Information',
      debt: 'Debt Securities',
      calendar: 'IR Calendar',
      news: 'Newsroom',
      activity: 'Activities & Presentations',
      publish: 'Published Documents',
      analyst: 'Analyst Information',
    },
    copyright: 'COPYRIGHT © 2019 , ORIGIN PROPERTY PUBLIC CO.,LTD ALL RIGHTS RESERVED.'
  },
  BasicInfoTabMenu: {
    info: "Basic Information",
    majorShareholders: "Major Shareholders",
    dividendPayment: "Dividend Payment",
    shareholderMeeting: "Shareholder Meeting",
    shareSubscription: "ORI - Share Subscription Rights & Details"
  },
  basicInformation: {
    pageTitle: 'Basic Information',
    breadcrumbHome: 'Investor Relations Home',
    breadcrumbShareholder: 'Shareholder Information',

    sectionHeader: 'General Company Information',
    companyName: 'Company Name',
    companyNameValue: 'Origin Property Public Company Limited (“the Company”)',

    stockSymbol: 'Stock Symbol',
    stockSymbolValue: 'ORI',

    businessType: 'Business Type',
    businessTypeValue: 'Real estate development business',

    companyRegistration: 'Company Registration Number',
    companyRegistrationValue: '0107557000381',

    registeredShares: 'Registered Shares',
    registeredSharesValue: '2,452,862,453 ordinary shares as of December 31, 2020',

    registeredCapital: 'Registered Capital',
    registeredCapitalValue: '1,545,776,222.50 Baht as of December 31, 2020',

    paidUpCapital: 'Paid-up Capital',
    paidUpCapitalValue: '1,226,431,226.50',

    shareParValue: 'Par Value per Share',
    shareParValueValue: '0.50 Baht per share',

    headOffice: 'Head Office Address',
    headOfficeValue: '496 Moo 9, Samrong Nuea Subdistrict, Mueang Samut Prakan District, Samut Prakan 10270',

    phone: 'Phone',
    phoneValue: '02 030 0000',

    fax: 'Fax',
    faxValue: '02 398 8066',

    contactAddress: 'Contact Address',
    contactAddressValue: '20th Floor, Bhiraj Tower at BITEC, 4345 Sukhumvit Road, Bangna, Bangkok 10260',

    website: 'Company Website',
    websiteValue: 'https://origin.co.th/',
  },
  listShareholderMajor: {
    pageTitle: 'Major Shareholders',
    breadcrumbHome: 'Investor Relations Home',
    breadcrumbShareholder: 'Shareholder Information',

    chartTitle: 'Top Shareholders',
    chartAsOf: 'As of May 30, 2025',
    tableAsOf: 'As of May 30, 2025',

    tableHeaderRank: 'No.',
    tableHeaderName: 'Shareholder Name',
    tableHeaderShares: 'Number of Shares',
    tableHeaderPercentage: '% of Shares',
  },
  dividendPayment: {
    pageTitle: 'Dividend Payment',
    breadcrumbHome: 'Investor Relations Home',
    breadcrumbShareholder: 'Shareholder Information',
    breadcrumbCurrent: 'Dividend Payment',

    description: 'The Company has a policy to pay dividends to shareholders twice a year at a total rate of not less than 40 percent of net profit per year according to the separate financial statements, after legal and company reserves. The Board of Directors considers dividend payments with regard to various factors, mainly for the benefit of shareholders, such as performance, financial position, investment plans, loan repayments, or working capital. The dividend payment must not significantly affect the Company’s normal operations, as deemed appropriate by the Board of Directors.',

    tableHeaderDecisionDate: 'Board Resolution Date',
    tableHeaderExDividendDate: 'Ex-Dividend Date',
    tableHeaderPaymentDate: 'Dividend Payment Date',
    tableHeaderType: 'Dividend Type',
    tableHeaderPerShare: 'Dividend per Share (Baht)',
    tableHeaderPeriod: 'Operating Period',

    cashDividend: 'Cash Dividend',
    stockDividend: 'Stock Dividend',

  },
  shareholderMeetings: {
    shareholderMeeting: "Shareholders' Meeting",
    investorHome: "Investor Relations Home",
    shareholderInfo: "Shareholder Information",
    selectYear: "Select Year",
    annualShareholdersMeeting: "Annual General Meeting",
    download: "Download",
    noData: "No meeting data for this year",
    document: "Document",
    meetingYear: "Year",
    meetingNumber: "No.",
  },
  financialInfoTabMenu: {
    importantFinancialInfo: 'Key Financial Information',
    financialStatements: 'Financial Statements',
    managementDiscussion: "Management's Discussion and Analysis",
  },
  financialInfo: {
    pageTitle: 'Key Financial Information',
    breadcrumbHome: 'Investor Relations Home',
    breadcrumbFinancial: 'Financial Information',

    total: 'Total Revenue',
    profit: 'Net Profit',

    sectionTitle: 'Key Financial Information',
    unit: 'Unit: Thousand Baht',

    tableHeaders: {
      year: ['2022', '2023', '2024'],
      section1: 'Key Financial Data',
      totalAssets: 'Total Assets',
      totalLiabilities: 'Total Liabilities',
      equity: 'Total Equity',
      salesRevenue: 'Revenue from Sales',
      totalRevenue: 'Total Revenue',
      costOfSales: 'Cost of Sales',
      totalExpenses: 'Total Expenses',
      netProfit: 'Net Profit (Equity holders of the Company)',
    },

    section2Title: 'Key Financial Ratios',
    ratios: {
      roe: 'Return on Equity (%)',
      roa: 'Return on Assets (%)',
      grossProfitMargin: 'Gross Profit Margin (%)',
      netProfitMargin: 'Net Profit Margin (%)',
      debtToEquity: 'Debt to Equity Ratio (D/E)',
      ibdToEquity: 'Interest-Bearing Debt to Equity Ratio (IBD/E)',
      assetTurnover: 'Total Asset Turnover (times)',
    },

    section3Title: 'Statistical Information',
    statistics: {
      registeredShares: 'Registered Shares (shares)',
      parValue: 'Par Value (Baht)',
      marketCap: 'Market Capitalization (Baht)',
      bvps: 'Book Value per Share (Baht/share)',
      eps: 'Earnings per Share (Baht/share)',
      peRatio: 'P/E Ratio (times)',
      pbvRatio: 'P/BV Ratio (times)',
    }
  },
  stockPriceInfo: {
    pageTitle: 'Stock Price Information',
    breadcrumbHome: 'Investor Relations Home',
    breadcrumbCurrent: 'Stock Price Information',
    breadcrumbTitle: 'Stock Price',

    volume: 'Trading Volume (shares)',
    prior: 'Previous Close',
    open: 'Opening Price',
    change: 'Change (% Change)',
    updated: 'Updated',
    offerVolume: 'Offer Price / Volume (shares)',
    bidVolume: 'Bid Price / Volume (shares)',
    dayRange: 'Day Range',
    currency: 'THB',
  },
  shareSubscription: {
    pageTitle: "ORI - Notification of Rights and Details for Subscription of Capital Increase Shares",
    breadcrumb: [
      { text: "Investor Relations Home", to: "/" },
      { text: "Shareholder Information" },
      { text: "ORI - Notification of Rights and Details for Subscription of Capital Increase Shares", isBold: true }
    ],
    tableTitle: "Document Information",
    downloadText: "Download"
  },
  statements: {
    pageTitle: 'Key Financial Information',
    breadcrumbHome: 'Investor Relations Home',
    breadcrumbSection: 'Financial Info',
    breadcrumbPage: 'Financial Statements',
    download: 'Download',
    quarterLabel: 'Quarter',
    selectYear: 'Select Year',
    document: 'Document',
    financialLabel: 'Financial Statements',
    year: 'Year'
  },
  description: {
    title: 'Management Discussion and Analysis',
    breadcrumbHome: 'Investor Relations Home',
    breadcrumbSection: 'Financial Info',
    breadcrumbPage: 'Management Discussion and Analysis',
    labelYear: 'Select Year',
    latestLabel: 'Management Discussion and Analysis',
    quarterTitle: 'Quarter',
    yearTitle: 'Year',
    download: 'Download',
    tableTitle: 'Management Discussion and Analysis Quarter',
    document: 'Document'
  },
  publishedDocsInfoTabMenu: {
    oneReport: 'Form 56-1 One Report',
    annualReport: 'Annual Report',
    sustainability: 'Sustainability Report',
    form561: 'Form 56-1',
    // downloadDocs: 'IR Document Downloads'
  },
  oneReports: {
    pageTitle: 'Form 56-1 One Report',
    breadcrumbHome: 'Investor Relations Home',
    breadcrumbSection: 'Published Documents',
    breadcrumbPage: 'Form 56-1 One Report',
    download: 'Download'
  },
  annualReport: {
    pageTitle: 'Annual Report',
    breadcrumbHome: 'Investor Relations Home',
    breadcrumbSection: 'Published Documents',
    breadcrumbPage: 'Annual Report',
    download: 'Download'
  },
  debtInfoTabMenu: {
    bondInfo: 'Bond Information',
    creditRating: 'Credit Rating',
    billExchange: 'Dealer Information (Bill of Exchange)'
  },
  debtInfo: {
    pageTitle: 'Debt Instruments',
    breadcrumbHome: 'Investor Relations Home',
    breadcrumbPage: 'Debt Instruments',
    table: {
      symbol: 'Symbol',
      issuedSize: 'Issued Size (MB)',
      outstanding: 'Outstanding (MB)',
      issueDate: 'Issue Date',
      maturityDate: 'Maturity Date',
      term: 'Term',
      interestRate: 'Interest Rate',
      total: 'Total'
    }
  },
  billExchange: {
    title: 'Dealer Information (Bill of Exchange)',
    menu: 'Debt Instruments',
    button: 'Visit Website',
    banks: {
      kkp: {
        name: 'Kiatnakin Phatra Bank',
        address: '209 KKP Tower, Sukhumvit 21 (Asoke), North Klongtoey, Wattana, Bangkok 10110\nTel: 02-165-5555',
        url: 'https://bank.kkpfg.com/th/home'
      },
      scb: {
        name: 'Siam Commercial Bank Public Company Limited',
        address: '9 Ratchadapisek Road, Chatuchak, Bangkok 10330\nTel: 02-544-5740',
        url: 'https://www.scb.co.th/en/personal-banking/'
      },
      kbank: {
        name: 'Kasikorn Bank Public Company Limited',
        address: '400/22 Phahonyothin Road, Samsen Nai, Phaya Thai, Bangkok 10400\nTel: 02-273-3337'
      },
      yuanta: {
        name: 'Yuanta Securities (Thailand) Co., Ltd.',
        address: '14-16th Floor, Gaysorn Tower, 127 Ratchadamri Road, Lumpini, Pathumwan, Bangkok 10330\nTel: 02-009-8889'
      }
    }
  },
  sustainabilityReport: {
    title: 'Sustainability Report',
    home: 'Investor Relations Home',
    menu: 'Published Documents',
    download: 'Download'
  },
  calendarInfo: {
    title: 'Investor Calendar',
    breadcrumb: 'Investor Calendar',
    home: 'IR Home',
    labelYear: 'Select Year',
    table: {
      date: 'Date',
      event: 'Event',
      detail: 'Detail'
    },
    loading: 'Loading...'
  },
  creditRating: {
    title: 'Credit Rating',
    breadcrumb: {
      home: 'Investor Relations Home',
      section: 'Debt Instruments',
      current: 'Credit Rating'
    },
    table: {
      date: 'Date',
      rating: 'Corporate Credit Rating',
      download: 'Download'
    }
  },
  analystInfoTabMenu: {
    contactAnalyst: 'Contact Analyst',
    securitiesAnalysis: 'Securities Analysis',
  },
  analyst: {
    title: 'Analyst Contacts',
    breadcrumb: {
      home: 'Investor Relations Home',
      section: 'Analyst Information',
      current: 'Analyst Contacts'
    },
    table: {
      company: 'Securities Company',
      name: 'Analyst Name',
      email: 'Email'
    }
  },
  InformationTabMenu: {
    contactInvestorRelations: 'Contact Investor Relations',
    subscribeEmail: 'Subscribe to Email News'
  },
  information: {
    title: "Contact Investor Relations",
    breadcrumbHome: "Investor Relations Home",
    breadcrumbInfo: "Contact Info",
    form: {
      heading: "Contact Investor Relations",
      phone: "Phone",
      fax: "Fax",
      email: "Email",
      firstname: "First Name",
      lastname: "Last Name",
      tel: "Phone Number",
      faxinput: "Fax",
      address: "Address",
      details: "Details",
      submit: "Send Message",
      placeholder: {
        firstname: "Enter first name",
        lastname: "Enter last name",
        tel: "e.g. 088xxxxxxx",
        fax: "e.g. 02xxxxxxx",
        details: "Type your message here!"
      },
      error: {
        firstname: "Please enter your first name",
        lastname: "Please enter your last name",
        tel: "Please enter a valid phone number",
        fax: "Please enter a valid fax number",
        address: "Please enter your address",
        details: "Please enter your message"
      },
      success: "Message sent successfully",
      fail: "Failed to send message. Please try again.",
      errorprocessing: "An error occurred while processing your request. Please try again later."
    }
  },
  receiveEmails: {
    home: "หน้าหลักนักลงทุนสัมพันธ์",
    placeholder: {
      fullName: "Enter your full name",
      email: "Enter your email",
      country: "Enter your country",
      occupation: "Enter your occupation",
      jobTitle: "Enter your job title",
      industry: "Enter your industry"
    },
    title: 'Receive Email Newsletter',
    breadcrumb: 'Information Inquiry',
    description1: 'You can subscribe to receive electronic newsletters. We will send updates via email.',
    description2: 'When there are announcements or website updates from the company published on this site.',
    description3: 'To register, please fill in your details and click the “Subscribe to Newsletter” button.',
    fullName: 'Full Name',
    email: 'Email*',
    country: 'Country',
    occupation: 'Occupation',
    jobTitle: 'Job Title',
    industry: 'Industry',
    subscribe: 'Subscribe to Newsletter',
    unsubscribePrompt: 'If you wish to unsubscribe from Origin Property Public Company Limited’s newsletter service,',
    unsubscribeHere: 'please click here',
    modalTitle1: 'Welcome to the Electronic Newsletter Service',
    modalTitle2: 'from Origin Property Public Company Limited',
    modalInstruction: 'Please enter your email address to unsubscribe from our electronic newsletter.',
    unsubscribe: 'Unsubscribe',
    close: 'Close',
    errorFullName: "Please enter your full name",
    errorEmail: "Please enter a valid email",
    errorCountry: "Please enter your country",
    errorOccupation: "Please enter your occupation",
    errorJobTitle: "Please enter your job title",
    errorIndustry: "Please enter your industry",
    success: "You have successfully subscribed to the newsletter.",
    fail: "There was a problem subscribing. Please try again.",
    error: "An error occurred. Please try again later.",
    unsubSuccess: "You have successfully unsubscribed from the newsletter.",
    unsubFail: "There was a problem unsubscribing. Please try again."
  },
  activityInfo: {
    title: 'Activities and Presentation Documents',
    breadcrumbHome: 'Investor Relations Home',
    breadcrumbCurrent: 'Activities and Presentations',
    yearLabel: 'Select Year',
    presentation: 'Presentation Activity',
    download: 'Download'
  },
  newInfoTabMenu: {
    setNews: 'SET News',
    mediaNews: 'Press Releases',
    printNews: 'Print Media Coverage',
    electronicAds: 'Electronic Advertising'
  },
  newInfo: {
    title: 'SET News',
    home: 'Investor Relations Home',
    newsRoom: 'Newsroom',
    readMore: 'Read more',
    search: 'Search',
    selectYear: 'Select Year',
    previous: 'Previous',
    next: 'Next',
  },
  newsMedia: {
    title: "Press Releases",
    home: "Investor Relations Home",
    newsRoom: "Newsroom",
    search: "Search",
    selectYear: "Select Year",
    readMore: "Read more"
  },
  newsPrintMedia: {
    title: "News from Print Media",
    home: "Investor Relations Home",
    newsRoom: "Newsroom",
    search: "Search",
    selectYear: "Select Year",
    readMore: "Read more",
    prev: "Previous",
    next: "Next"
  },
  electronicAdvertising: {
    title: "Electronic Advertising",
    home: "Investor Relations Home",
    newsRoom: "Newsroom",
    search: "Search",
    selectYear: "Select Year",
    readMore: "Read more",
    prev: "Previous",
    next: "Next"
  },
  form56_1: {
    title: "Form 56-1",
    annual:"Year",
    home: "Investor Relations Home",
    section: "Published Documents",
    download: "Download",
    reportTitle: "Form 56-1 REPORT"
  },
  securitiesAnalysis: {
    title: "Securities Analysis",
    home: "Investor Relations Home",
    section: "Analyst Information",
    selectYear: "Select Year",
    company: "Securities Company",
    date: "Date",
    download: "Download PDF"
  },
  warrantInfo: {
    title: "Information for Warrant Holders",
    home: "Investor Relations Home",
    round6: "6th Round",
    lastRound: "Final Round",
    row1: "Terms and Conditions of Warrant Issuer and Holders",
    row2: "Summary Information, Terms and Conditions of Warrants to Purchase Capital Increase Ordinary Shares (ORI - W2)",
    row3: "Notification of the Schedule for the Exercise of Rights to Purchase the Newly Issued Ordinary Shares of ORIGIN PROPERTY PUBLIC COMPANY LIMITED under the ORI-W2 Warrants (the 1st Exercise)",
    row4: "Form for the Notification of Intention to Exercise the Rights to Purchase the Newly Issued Ordinary Shares of ORIGIN PROPERTY PUBLIC COMPANY LIMITED No.2 (“ORI-W2”)"
  }
  
}
